document.addEventListener('DOMContentLoaded',()=>{
  const params=new URLSearchParams(location.search);
  const model=document.getElementById('contact-model');
  if(model&&params.has('model')) model.value=params.get('model').slice(0,200);
  const message=document.getElementById('contact-message');
  if(message&&params.get('subiect')==='parteneriat') message.value='Doresc informații despre colaborarea B2B pentru produsele Zupper.\nDomeniul de activitate: \nModele / categorii de interes: ';
  const menus=[...document.querySelectorAll('.site-header details')];
  for(const menu of menus) menu.addEventListener('toggle',()=>{if(menu.open) for(const other of menus) if(other!==menu) other.open=false;});
  document.addEventListener('keydown',e=>{if(e.key==='Escape') menus.forEach(m=>{if(m.open){m.open=false;m.querySelector('summary').focus();}});});
  document.addEventListener('click',e=>{menus.forEach(m=>{if(m.open&&!m.contains(e.target))m.open=false;});});
  if(window.matchMedia('(max-width:650px)').matches){const sidebar=document.querySelector('.catalog-sidebar details');if(sidebar)sidebar.open=false;}
});
